import { createFileRoute, Link } from "@tanstack/react-router";
import { trpc } from "@/hooks/trpc";
import { MapPin } from "lucide-react";

export const Route = createFileRoute("/")({
  component: RoomsIndex,
});

function RoomsIndex() {
  const { data: rooms, isLoading } = trpc.rooms.list.useQuery();

  if (isLoading) {
    return (
      <div className="mx-auto max-w-7xl px-4 py-8">
        <div className="animate-pulse space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-24 rounded-lg bg-muted" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-7xl px-4 py-8">
      <h1 className="mb-6 text-2xl font-bold">Meeting Rooms</h1>

      {!rooms?.length ? (
        <div className="rounded-lg border border-border bg-card p-8 text-center">
          <p className="text-muted-foreground">
            No rooms configured yet. Go to the{" "}
            <Link to="/admin" className="text-primary underline">
              admin panel
            </Link>{" "}
            to add rooms.
          </p>
        </div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {rooms.map((room) => (
            <Link
              key={room.id}
              to="/room/$roomId"
              params={{ roomId: room.id }}
              className="group rounded-lg border border-border bg-card p-6 transition-shadow hover:shadow-md"
            >
              <h2 className="text-lg font-semibold group-hover:text-primary transition-colors">
                {room.name}
              </h2>
              <div className="mt-2 flex items-center gap-4 text-sm text-muted-foreground">
                <span className="flex items-center gap-1">
                  <MapPin className="h-4 w-4" />
                  {room.location}
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
